<div class="container save-quote-outer-container common-text-font">
  <div class="row">
    <div class="col-md-12">
      <form title="yourSavedQuoteForm" [formGroup]="yourSavedQuoteForm" autocomplete="off">
        <div class="container save-quote-container save-quote-card">
          <div class="row fixed-width">
            <div class="col-md-12">
              <h2 class="save-quote-title">
                {{contentData.yourSaveQuotetext}}
              </h2>
            </div>
          </div>
        </div>
        
	<div class="container content-container">
          <div *ngIf="partialApplicationsResultArray?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 class="content-header">{{contentData.applicationProgressHeader}}</h2>
              </div>
              <div class="col-md-12 content-text-container">
                <span class="content-text">{{contentData.applicationProgressText}}</span>
              </div>
            </div>
            <div class="row">
              <ng-container
                *ngFor="let partialApplication of partialApplicationsResultArray; let iteration=index ; last as isLast">
                <div
                  [ngClass]=" isLast && !indicativeQuoteResultArray && !partialQuoteResultArray  ? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <ng-container *ngIf="partialApplication.isGMP && partialApplication.isGMP === 'Y';else nonGMP">
                    <app-gmp-annuity-quote [iterationId]="'PartialApp'+iteration" [SelectedGMP]="partialApplication"
                      [loadingPDFFlag]="loadingPDFFlag"
                      (riskQuestionEmitter)="openPersonalisedQuote(partialApplication)" [isDocumentRequired]="true"
                      [tileType]="'application'"></app-gmp-annuity-quote>
                  </ng-container>

                  <ng-template #nonGMP>
                    <div *ngIf="partialApplication.selectedProduct === 'C'">
                      <app-selected-product-quote [iterationId]="'PartialApp'+iteration"
                        [Selectedproductquote]="partialApplication" [loadingPDFFlag]="loadingPDFFlag"
                        (riskQuestionEmitter)="openPersonalisedQuote(partialApplication)" [isDocumentRequired]="true"
                        [tileType]="'application'"></app-selected-product-quote>
                    </div>
                    <div *ngIf="partialApplication.selectedProduct === 'H'">
                      <app-ftrp-product-quote [iterationId]="'PartialApp'+iteration"
                        [SelectedProductQuoteFTRP]="partialApplication" [loadingPDFFlag]="loadingPDFFlag"
                        (riskQuestionEmitter)="openPersonalisedQuote(partialApplication)" [isDocumentRequired]="true"
                        [tileType]="'application'"></app-ftrp-product-quote>
                    </div>
                    <div *ngIf="partialApplication.selectedProduct === 'G'">
                      <app-corp-product-quote [iterationId]="'PartialApp'+iteration"
                        [SelectedProductQuoteCORP]="partialApplication" [loadingPDFFlag]="loadingPDFFlag"
                        (riskQuestionEmitter)="openPersonalisedQuote(partialApplication)" [isDocumentRequired]="true"
                        [tileType]="'application'"></app-corp-product-quote>
                    </div>
                  </ng-template>
                  <div class="container border-bot-container">
		                <div class="col-md-12 bg-lightblue line-border" *ngIf="partialApplication.fundingSource === 'F'">
              		    <p class="inner-content-data">{{getSlocWarningText('A')}}</p>
            	      </div>
                  </div>
                  <div class="row button-container" *ngIf="partialApplication.fundingSource !== 'F'">
                    <div class="flex-50">
                      <button id="btnRemoveApplication{{iteration}}"
                        (click)="cancelApplication(customerId, partialApplication.applicationId)"
                        class="btn btn-tertiary" type="button">{{contentData.btnCancelApplication}}</button>
                    </div>
                    <div class="flex-50 display-flex">
                      <button id="btnResumeApplication{{iteration}}"
                        (click)="resumeApplication(partialApplication.applicationId,partialApplication.quoteExpiry,partialApplication.quoteRefNo)"
                        class="btn btn-primary m-l-auto" type="button">{{contentData.btnResumeQuote}}</button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <!-- Partial Application Tile Section Ends -->
          <!--Start Application Submitted tile-->
          <div *ngIf="submittedApplicationsResultArray?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 class="content-header">{{contentData.applicationSubmitedHeader}}</h2>
              </div>
              <div class="col-md-12 content-text-container">
                <span class="content-text">{{contentData.applicationSubmittedText}}</span>
              </div>
            </div>

            <div class="row">
              <ng-container
                *ngFor="let submitedApplication of submittedApplicationsResultArray; let iteration=index ; last as isLast">
                <div
                  [ngClass]=" isLast && !indicativeQuoteResultArray && !partialQuoteResultArray  ? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <ng-container *ngIf="submitedApplication.isGMP && submitedApplication.isGMP === 'Y';else nonGMP">
                    <app-gmp-annuity-quote [iterationId]="'SubmitedApp'+iteration" [SelectedGMP]="submitedApplication"
                      [loadingPDFFlag]="loadingPDFFlag"
                      (riskQuestionEmitter)="openPersonalisedQuote(submitedApplication)" [isDocumentRequired]="true"
                      [tileType]="'application'"></app-gmp-annuity-quote>
                  </ng-container>
                  <ng-template #nonGMP>
                    <div *ngIf="submitedApplication.selectedProduct === 'C'">
                      <app-selected-product-quote [iterationId]="'SubmitedApp'+iteration"
                        [Selectedproductquote]="submitedApplication" [loadingPDFFlag]="loadingPDFFlag"
                        (riskQuestionEmitter)="openPersonalisedQuote(submitedApplication)" [isDocumentRequired]="true"
                        [tileType]="'application'"></app-selected-product-quote>
                    </div>
                    <div *ngIf="submitedApplication.selectedProduct === 'H'">
                      <app-ftrp-product-quote [iterationId]="'SubmitedApp'+iteration"
                        [SelectedProductQuoteFTRP]="submitedApplication" [loadingPDFFlag]="loadingPDFFlag"
                        (riskQuestionEmitter)="openPersonalisedQuote(submitedApplication)" [isDocumentRequired]="true"
                        [tileType]="'application'"></app-ftrp-product-quote>
                    </div>
                    <div *ngIf="submitedApplication.selectedProduct === 'G'">
                      <app-corp-product-quote [iterationId]="'SubmitedApp'+iteration"
                        [SelectedProductQuoteCORP]="submitedApplication" [loadingPDFFlag]="loadingPDFFlag"
                        (riskQuestionEmitter)="openPersonalisedQuote(submitedApplication)" [isDocumentRequired]="true"
                        [tileType]="'application'"></app-corp-product-quote>
                    </div>
                  </ng-template>
                  <div class="container border-bot-container"></div>

                  <div class="row view-button-container">
                    <div class="flex-100">
                      <button id="btnViewApplication{{iteration}}"
                        (click)="viewApplication(submitedApplication.applicationId)"
                        style="margin-right: 0px !important;" class="btn btn-primary"
                        type="button">{{contentData.btnViewApplication}}</button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <!--End Application Submited tile-->
          <!--Start Guaranteed Quotes tile-->
          <div *ngIf="guaranteedQuoteResultArray?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 class="content-header">{{contentData.guaranteedquotesHeader}}
                </h2>
              </div>

              <div class="col-md-12 content-text-container">
                <span class="content-text">{{contentData.guaranteedquotesText}}
                </span>
              </div>
            </div>

            <div class="row">
              <ng-container
                *ngFor="let guaranteedQuote of guaranteedQuoteResultArray; let iteration=index ; last as isLast">
                <div
                  [ngClass]=" isLast && !indicativeQuoteResultArray && !partialQuoteResultArray  ? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <ng-container *ngIf="guaranteedQuote.isGMP && guaranteedQuote.isGMP === 'Y';else nonGMP">
                    <app-gmp-annuity-quote [iterationId]="iteration" [SelectedGMP]="guaranteedQuote"
                      [isDocumentRequired]="false" [tileType]="'quote'"></app-gmp-annuity-quote>
                  </ng-container>
                  <ng-template #nonGMP>
                    <div *ngIf="guaranteedQuote.selectedProduct === 'C'">
                      <app-selected-product-quote [iterationId]="'guaranteed'+iteration"
                        [Selectedproductquote]="guaranteedQuote" [isDocumentRequired]="false"
                        [tileType]="'quote'"></app-selected-product-quote>
                    </div>
                    <div *ngIf="guaranteedQuote.selectedProduct === 'H'">
                      <app-ftrp-product-quote [iterationId]="'guaranteed'+iteration"
                        [SelectedProductQuoteFTRP]="guaranteedQuote" [isDocumentRequired]="false"
                        [tileType]="'quote'"></app-ftrp-product-quote>
                    </div>
                    <div *ngIf="guaranteedQuote.selectedProduct === 'G'">
                      <app-corp-product-quote [iterationId]="'guaranteed'+iteration"
                        [SelectedProductQuoteCORP]="guaranteedQuote" [isDocumentRequired]="false"
                        [tileType]="'quote'"></app-corp-product-quote>
                    </div>
                  </ng-template>
                  <!-- <div class="col-md-11 line-border">

                  </div> -->
                  <div class="container border-bot-container">
                      <div class="col-md-12  bg-lightblue line-border" *ngIf="guaranteedQuote.fundingSource === 'F'">
                        <p class="inner-content-data">{{getSlocWarningText('Q')}}</p>
                      </div>
                    </div>
                  <div *ngIf="guaranteedQuote.fundingSource !== 'F' && (guaranteedQuote.requoteInd === 'N' || isGARCheck(guaranteedQuote.garIndicator))"
                    class="row warning-container">
                    <div class="col-md-11  bg-lightblue line-border">
                      <p class="inner-content-data">
                        {{contentData.callHOforQuote}}</p>
                    </div>
                  </div>
                  <!-- <div style="width: 100%;" class="float-right guaranteedQuoteButton w-100">
                    <div style="flex: 1">
                      <button *ngIf="guaranteedQuote.requoteInd === 'Y' && !isGARCheck(guaranteedQuote.garIndicator)"
                        id="btnRequote{{iteration}}"
                        (click)="reQuote(guaranteedQuote.quoteRefNo,guaranteedQuote.selectedProduct,guaranteedQuote.productOptions)"
                        class="btn btn-secondary flex-content" type="button">{{contentData.btnGetanotherquote}}</button>
                    </div>
                    <button id="btnViewQuote{{iteration}}" (click)="viewQuote(guaranteedQuote.quoteRefNo)" class="btn btn-primary"
                      type="button">{{contentData.btnViewQuote}}</button>
                  </div> -->

                  <div class="row new-view-quote-btn-container ">
                    <div class="new-view-quote-flex-50">
                      <button *ngIf="guaranteedQuote.fundingSource !== 'F' && guaranteedQuote.requoteInd === 'Y' && !isGARCheck(guaranteedQuote.garIndicator)"
                        id="btnRequote{{iteration}}"
                        (click)="reQuote(guaranteedQuote.quoteRefNo,guaranteedQuote.selectedProduct,guaranteedQuote.productOptions)"
                        class="btn btn-secondary flex-content" type="button">{{contentData.btnGetanotherquote}}</button>
                    </div>
                    <div class="new-view-quote-flex-50 display-flex">
                      <button id="btnViewQuote{{iteration}}" (click)="viewQuote(guaranteedQuote.quoteRefNo)"
                        class="btn btn-primary m-l-auto" type="button">{{contentData.btnViewQuote}}</button>
                    </div>
                  </div>
                </div>

              </ng-container>
            </div>
          </div>
          <!--End Guaranteed Quotes tile-->
          <!--Start Indicatve Quotes tile-->
          <div *ngIf="indicativeQuoteResultArray?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 id="indicativeCodeheader" class="content-header">
                  {{contentData.indicativeQuoteHeader}}
                </h2>
              </div>

              <div class="col-md-12 content-text-container">
                <span id="guarantedCodeText" class="content-text">
                  {{contentData.indicativequotesText}}
                </span>
              </div>
            </div>

            <div class="row">
              <ng-container
                *ngFor="let indicativequote of indicativeQuoteResultArray; let iteration=index; last as islast">
                <div
                  [ngClass]=" isLast && !partialQuoteResultArray? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <ng-container *ngIf="indicativequote.isGMP && indicativequote.isGMP === 'Y';else nonGMP">
                    <app-gmp-annuity-quote [iterationId]="iteration" [SelectedGMP]="indicativequote"
                      [isDocumentRequired]="false" [tileType]="'quote'"></app-gmp-annuity-quote>
                  </ng-container>
                  <ng-template #nonGMP>
                    <div>
                      <app-selected-product-quote [tileType]="'quote'" [isValidCard]=false
                        [iterationId]="'IndicativeQuote'+iteration" [Selectedproductquote]="indicativequote"
                        [isDocumentRequired]="false"></app-selected-product-quote>
                      <!-- <app-lta-indicative-quote [iterationId]="iteration" [Indicativequote]="indicativequote" 
                             [isDocumentRequired]="false"></app-lta-indicative-quote>-->
                    </div>
                  </ng-template>
                  <div class="container border-bot-container">
                    <div class="col-md-12  bg-lightblue line-border" *ngIf="indicativequote.fundingSource === 'F'">
                      <p class="inner-content-data">{{getSlocWarningText('Q')}}</p>
                    </div>
                  </div>
                  <div *ngIf="indicativequote.fundingSource !== 'F' && indicativequote.requoteInd === 'N'" class="row warning-container">
                    <div class="col-md-11  bg-lightblue line-border">
                      <p class="inner-content-data">
                        {{contentData.callHOforQuote}}</p>
                    </div>
                  </div>
                  <!-- <div style="width: 100%;" class=" float-right guaranteedQuoteButton">
                    <div style="flex: 1">
                      <button *ngIf="indicativequote.requoteInd === 'Y'" id="btnRequoteIndicative{{iteration}}"
                        (click)="reQuote(indicativequote.quoteRefNo,indicativequote.selectedProduct,indicativequote.productOptions)"
                        class="btn btn-secondary flex-content" type="button">{{contentData.btnGetanotherquote}}</button>
                    </div>
                    <button id="btnViewIndicativeQuote{{iteration}}" (click)="viewQuote(indicativequote.quoteRefNo)"
                      style="margin-right: 0px !important;" class="btn btn-primary" type="button">
                      {{contentData.btnViewQuote}}</button>
                  </div> -->
                  <div class="container border-bot-container"></div>

                  <div class="row new-view-quote-btn-container">
                    <div class="new-view-quote-flex-50">
                      <button *ngIf="indicativequote.fundingSource !== 'F' && indicativequote.requoteInd === 'Y'" id="btnRequoteIndicative{{iteration}}"
                        (click)="reQuote(indicativequote.quoteRefNo,indicativequote.selectedProduct,indicativequote.productOptions)"
                        class="btn btn-secondary flex-content" type="button">{{contentData.btnGetanotherquote}}</button>
                    </div>
                    <div class="new-view-quote-flex-50 display-flex">
                      <button id="btnViewIndicativeQuote{{iteration}}" (click)="viewQuote(indicativequote.quoteRefNo)"
                        style="margin-right: 0px !important;" class="btn btn-primary m-l-auto" type="button">
                        {{contentData.btnViewQuote}}</button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

          </div>
          <!--End Indicatve Quotes tile-->
          <!--Start Partial Quotes tile-->
          <div *ngIf="partialQuoteResultArray?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 class="content-header">{{contentData.progressQuoteHeader}}
                </h2>
              </div>

              <div class="col-md-12 content-text-container">
                <span class="content-text">{{contentData.progressQuoteText}}
                </span>
              </div>
            </div>

            <div class="row">
              <ng-container *ngFor="let partialQuote of partialQuoteResultArray; let iteration=index; last as isLast">
                <div [ngClass]=" isLast ? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <div class="row">
                    <app-partial-product-quote [iterationId]="'Partial'+iteration" [Partialproductquote]="partialQuote"
                      [isDocumentRequired]="false"></app-partial-product-quote>
                  </div>
                  <!-- <div class="float-right guaranteedQuoteButton">
                      <div class="col-md-12 text-right padding-right-0">
                        <button id="btnResumeQuote{{iteration}}" (click)="ResumeQuote(partialQuote.quoteRefNo)"
                          style="margin-right: 0px !important;" class="btn btn-primary"
                          type="button">{{contentData.btnResumeQuote}}</button>
                      </div>
                    </div> -->
                  <div class="container border-bot-container">
                    <div class="col-md-12  bg-lightblue line-border" *ngIf="partialQuote.fundingSource === 'F'">
                        <p class="inner-content-data">{{getSlocWarningText('Q')}}</p>
                    </div>
                  </div>
                  <div class="row view-button-container">
                    <div class="flex-100">
                      <button id="btnResumeQuote{{iteration}}" (click)="ResumeQuote(partialQuote.quoteRefNo)"
                        style="margin-right: 0px !important;" class="btn btn-primary" type="button" *ngIf="partialQuote.fundingSource !== 'F'">
                        {{contentData.btnResumeQuote}}</button>
                    </div>

                  </div>
                </div>

              </ng-container>
            </div>
          </div>
          <!--End Partial Quotes tile-->
          <!--all invalid quote as follows-->
          <div *ngIf="invalidQuoteResultArrayApi?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 class="content-header">{{contentData.invalidateGuaranteedquotesHeader}}
                </h2>
              </div>

              <div class="col-md-12 content-text-container">
                <span class="content-text">{{contentData.invalidateGuaranteedquotesText}}
                </span>
              </div>
            </div>

            <div class="row">
              <ng-container
                *ngFor="let invalidguaranteedQuote of invalidGuaranteedQuoteArray; let iteration=index ; last as isLast">
                <div
                  [ngClass]=" isLast && !invalidGuaranteedQuoteArray && !partialQuoteResultArray  ? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <div *ngIf="invalidguaranteedQuote.selectedProduct === 'C'">
                    <ng-container *ngIf="invalidguaranteedQuote.isGMP === 'Y';else nonGMPLTA">
                      <app-gmp-annuity-quote
                        [iterationId]="invalidguaranteedQuote.indicative !== 'Y' ? 'iteration' : ('IndicativeQuote'+iteration)"
                        [isValidCard]=false [SelectedGMP]="invalidguaranteedQuote" [isDocumentRequired]="false"
                        [tileType]="'quote'"></app-gmp-annuity-quote>
                    </ng-container>
                    <ng-template #nonGMPLTA>
                      <app-selected-product-quote [tileType]="'quote'" [isValidCard]=false
                        [iterationId]="invalidguaranteedQuote.indicative !== 'Y' ? 'iteration' : ('IndicativeQuote'+iteration)"
                        [Selectedproductquote]="invalidguaranteedQuote"
                        [isDocumentRequired]="false"></app-selected-product-quote>
                    </ng-template>
                  </div>
                  <div *ngIf="invalidguaranteedQuote.selectedProduct === 'H'">
                    <app-ftrp-product-quote [tileType]="'quote'" [isValidCard]=false [iterationId]="iteration"
                      [SelectedProductQuoteFTRP]="invalidguaranteedQuote"
                      [isDocumentRequired]="false"></app-ftrp-product-quote>
                  </div>
                  <div *ngIf="invalidguaranteedQuote.selectedProduct === 'G'">
                    <app-corp-product-quote [tileType]="'quote'" [isValidCard]=false [iterationId]="iteration"
                      [SelectedProductQuoteCORP]="invalidguaranteedQuote"
                      [isDocumentRequired]="false"></app-corp-product-quote>
                  </div>
                  <div class="container border-bot-container">
                    <div class="col-md-12  bg-lightblue line-border" *ngIf="invalidguaranteedQuote.fundingSource === 'F'">
                      <p class="inner-content-data">{{getSlocWarningText('Q')}}</p>
                    </div>
                  </div>
		  
                  <div *ngIf="invalidguaranteedQuote.fundingSource !== 'F' && invalidguaranteedQuote.requoteInd === 'N'" class="row warning-container">
                    <div class="col-md-11  bg-lightblue line-border">
                      <p class="inner-content-data">
                        {{contentData.callHOforQuote}}</p>
                    </div>
                  </div>
                  <!-- <div class="float-right guaranteedQuoteButton">
                    <button *ngIf="invalidguaranteedQuote.requoteInd === 'Y'" id="btnInvalidRequote{{iteration}}"
                      (click)="reQuote(invalidguaranteedQuote.quoteRefNo,invalidguaranteedQuote.selectedProduct,invalidguaranteedQuote.productOptions)"
                      style="margin-right: 30px !important;" class="btn btn-secondary"
                      type="button">{{contentData.btnGetanotherquote}}</button>
                  
                  </div> -->
                  <div class="container border-bot-container"></div>

                  <div class="row view-button-container">
                    <div class="flex-100">
                      <button *ngIf="invalidguaranteedQuote.fundingSource !== 'F' && invalidguaranteedQuote.requoteInd === 'Y'" id="btnInvalidRequote{{iteration}}"
                        (click)="reQuote(invalidguaranteedQuote.quoteRefNo,invalidguaranteedQuote.selectedProduct,invalidguaranteedQuote.productOptions)"
                        style="margin-right: 30px !important;" class="btn btn-secondary"
                        type="button">{{contentData.btnGetanotherquote}}</button>
                    </div>
                  </div>
                </div>

              </ng-container>
            </div>
          </div>
          <!--all invalid quote end-->
          <!--all expired quote as follows-->
          <div *ngIf="expiredQuoteResultArray?.length > 0">
            <div class="row">
              <div class="col-md-12">
                <h2 class="content-header">{{contentData.expiredQuotesHeader}}
                </h2>
              </div>
              <div class="col-md-12 content-text-container">
                <span class="content-text">{{contentData.expiredQuotesText}}
                </span>
              </div>
            </div>

            <div class="row">
              <ng-container *ngFor="let expiredQuote of expiredQuoteResultArray; let iteration=index; last as islast">
                <div
                  [ngClass]=" isLast && !indicativeQuoteResultArray && !partialQuoteResultArray  ? 'guaranteedQuoteCard remove-mb' : 'guaranteedQuoteCard'">
                  <div *ngIf="expiredQuote.selectedProduct === 'C'">
                    <app-selected-product-quote [iterationId]="'Expired'+iteration"
                      [Selectedproductquote]="expiredQuote" [isDocumentRequired]="false" [tileType]="'quote'"
                      [isValidCard]=false></app-selected-product-quote>
                  </div>
                  <div *ngIf="expiredQuote.selectedProduct === 'H'">
                    <app-ftrp-product-quote [iterationId]="'Expired'+iteration"
                      [SelectedProductQuoteFTRP]="expiredQuote" [isDocumentRequired]="false" [tileType]="'quote'"
                      [isValidCard]=false></app-ftrp-product-quote>
                  </div>
                  <div *ngIf="expiredQuote.selectedProduct === 'G'">
                    <app-corp-product-quote [iterationId]="'Expired'+iteration"
                      [SelectedProductQuoteCORP]="expiredQuote" [isDocumentRequired]="false" [tileType]="'quote'"
                      [isValidCard]=false></app-corp-product-quote>
                  </div>
                  <div class="container border-bot-container">
                    <div class="col-md-12 bg-lightblue line-border" *ngIf="expiredQuote.fundingSource === 'F'">
                      <p class="inner-content-data">{{getSlocWarningText('Q')}}</p>
                    </div>
                  </div>
		  
                  <div *ngIf="expiredQuote.fundingSource !== 'F' && expiredQuote.requoteInd === 'N'" class="row warning-container">
                    <div class="col-md-11  bg-lightblue line-border">
                      <p class="inner-content-data">
                        {{contentData.callHOforQuote}}</p>
                    </div>
                  </div>
                  <!-- <div class="float-right guaranteedQuoteButton">
                    <button *ngIf="expiredQuote.requoteInd === 'Y'" id="btnExpiredQuote{{iteration}}"
                      (click)="requoteExpiry(expiredQuote.quoteRefNo)" style="margin-right: 30px !important;" class="btn btn-secondary"
                      type="button">{{contentData.btnRefreshQuote}}</button></div> -->
                  <div class="container border-bot-container"></div>

                  <div class="row view-button-container">
                    <div class="flex-100">
                      <button *ngIf="expiredQuote.fundingSource !== 'F' &&  expiredQuote.requoteInd === 'Y'" id="btnExpiredQuote{{iteration}}"
                        (click)="requoteExpiry(expiredQuote.quoteRefNo)" style="margin-right: 30px !important;"
                        class="btn btn-secondary" type="button">{{contentData.btnRefreshQuote}}</button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <!--all expired quote end-->


        </div>

        <div class="container border-bot-container"></div>


      </form>
      <app-modal *ngIf="displayCancelAlert" [modalConfig]="cancelApplicationAlertModalConfig"
        (closeModal)="cancelCloseModal()" (primaryBtnClick)="cancelAlertPrimaryBtnClick(applicationId)"
        (secondaryBtnClick)="cancelAlertSecondaryBtnClick(customerId,applicationId)" [saveDataFlag]="false"></app-modal>
      <app-modal *ngIf="displayResumeAlert" [modalConfig]="resumeApplicationAlertModalConfig"
        (closeModal)="resumeCloseModal()" (primaryBtnClick)="resumeAlertPrimaryBtnClick()"
        (secondaryBtnClick)="resumeAlertSecondaryBtnClick(applicationId)" [saveDataFlag]="false"></app-modal>
      <app-modal *ngIf="showPopupGuidanceANdAdvice" [modalConfig]="guidanceAndAdviceModalConfig" [primaryLayout]="true"
        (primaryBtnClick)="resumeGuidanceAndAdvice()" [saveDataFlag]="false"></app-modal>
      <app-modal-option [modalConfig]="requotealertModalConfig" *ngIf="displayAlertRequote" (closeModal)="closeModal()"
        (primaryBtnClick)="alertPrimaryRequoteBtnClick()"
        (secondaryBtnClick)="alertSecondaryRequoteBtnClick()"></app-modal-option>
    </div>
  </div>
</div>